import { render, staticRenderFns } from "./WidgetExamples.vue?vue&type=template&id=3463ffd3&scoped=true&"
import script from "./WidgetExamples.vue?vue&type=script&lang=ts&"
export * from "./WidgetExamples.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetExamples.vue?vue&type=style&index=0&id=3463ffd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3463ffd3",
  null
  
)

export default component.exports